/**
 * The one place platform brand colors live for dots/headers. Extracted from
 * Insights.tsx the day the Dashboard needed the same dots — two copies of a
 * brand map drift, and the day they disagree neither is the brand's.
 */

export const PLATFORM_COLORS: Record<string, string> = {
  facebook: "#1877F2",
  google: "#4285F4",
  google_ads: "#4285F4",
  google_analytics: "#E37400",
  analytics: "#E37400",
  line: "#06C755",
  tiktok: "#111111",
};

export const PlatformDot: React.FC<{ platform: string }> = ({ platform }) => (
  <span
    className="inline-block w-2.5 h-2.5 rounded-sm shrink-0"
    style={{ backgroundColor: PLATFORM_COLORS[platform] ?? "#9CA3AF" }}
    aria-hidden="true"
  />
);
